import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../assets/Logo.svg";
import ColoredLogo from "../assets/ColoredLogo.svg";
import Button from "../components/button/Button";
import GiftIcon from "../assets/gift.svg";
import RatesIcon from "../assets/Currency.svg";
import HeartIcon from "../assets/heart.svg";
import HeadphoneIcon from "../assets/headPhone.svg";
import CrownIcon from "../assets/Crown.svg";
import MedalIcon from "../assets/medal.svg";
import Cancel from "../assets/cancel.svg";
import "./NavBar.css";

const NavBar = ({
  linkColor = "#fff",
  logo = Logo,
  bg = styles.background,
}) => {
  // const menuRef = useRef(null);

  const [menuOpen, setMenuOpen] = useState(false);
  const [hoverMenu, setHoverMenu] = useState({
    giftCard8: false,
    giftCards: false,
  });

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <section className="nav-section fixed-top" style={{ background: bg }}>
      <nav className="container nav-container">
        <div className="logo-container">
          <NavLink
            to="/"
            className="logo-link"
            onClick={() => window.scrollTo(0, 0)}
          >
            <img src={logo} alt="Logo" className="logo" />
          </NavLink>
        </div>
        <button className="menu-toggle mt-1" onClick={toggleMenu}>
          <i className="bi bi-list fs-3" style={{ color: linkColor }}></i>
        </button>
        <div
          // ref={menuRef}
          className={`nav-subcontainer ${menuOpen ? "open" : ""}`}
        >
          <div className="nav-item-container">
            <div className="mobile-logo-container">
              <NavLink
                to="/"
                className="logo-link"
                onClick={() => window.scrollTo(0, 0)}
              >
                <img src={ColoredLogo} alt="coloured Logo" className="coloredlogo" />
              </NavLink>
              <button className="menu-toggle" onClick={toggleMenu}>
                <img
                  src={menuOpen ? Cancel : Cancel}
                  alt="Menu Icon"
                  className="cancel"
                />
              </button>
            </div>
            <li className="nav-item dropdown bordered">
              <NavLink
                className="nav-link hover-effect"
                id="giftCardHover"
                alt="GiftCard8"
                style={{ color: linkColor }}
                onClick={() => {
                  setHoverMenu({
                    giftCard8: !hoverMenu.giftCard8, // Toggle the current menu
                    giftCards: false, // Close the other menu
                  });
                  window.scrollTo(0, 0);
                }}
              >
                GiftCard8
              </NavLink>
              <div
                className={`hover-menu ${
                  hoverMenu.giftCard8 ? "show-sub-menu" : ""
                }`}
              >
                <div className="hover-item">
                  <NavLink
                    to="/Product-Features"
                    className="hover-link hover-effect"
                    style={{ color: "#000" }}
                    alt="Product Features"
                    onClick={(e) => {
                      if (menuOpen) toggleMenu();
                      if (window.location.pathname === "/Product-Features") {
                        e.preventDefault();
                        window.location.reload();
                      } else {
                        window.scrollTo(0, 0);
                      }
                    }}
                  >
                    <div className="hover-content">
                      <span
                        className="icon mx-2 px-4 py-2 rounded-4"
                        style={{ background: "#F0F8FF" }}
                      >
                        <img
                          src={HeartIcon}
                          alt="icon"
                          style={{ color: "#000" }}
                        />
                      </span>
                      <div>
                        <h6>Product Features</h6>
                        <p>
                          Your go-to platform for selling gift cards with ease
                          and confidence
                        </p>
                      </div>
                    </div>
                  </NavLink>
                </div>
                <div className="hover-item">
                  <NavLink
                    to="/Vip-Upgrades"
                    className="hover-link hover-effect"
                    style={{ color: "#000" }}
                    alt="VIP Upgrades"
                    onClick={(e) => {
                      if (menuOpen) toggleMenu(); // Close the menu if it's open
                      if (window.location.pathname === "/Vip-Upgrades") {
                        e.preventDefault(); // Prevent the default navigation
                        window.location.reload(); // Reload the page
                      } else {
                        window.scrollTo(0, 0); // Scroll to the top for normal navigation
                      }
                    }}
                  >
                    <div className="hover-content">
                      <span
                        className="icon mx-2 px-4 py-2 rounded-4"
                        style={{ background: "#F0F8FF" }}
                      >
                        <img
                          src={CrownIcon}
                          alt="icon"
                          style={{ color: "#000" }}
                        />
                      </span>
                      <div>
                        <h6>VIP Upgrades</h6>
                        <p>Enjoy exclusive privileges and VIP cashback</p>
                      </div>
                    </div>
                  </NavLink>
                </div>
                <div className="hover-item">
                  <NavLink
                    to="/about-us"
                    className="hover-link hover-effect"
                    style={{ color: "#000" }}
                    alt="About Us"
                    onClick={(e) => {
                      if (menuOpen) toggleMenu(); // Close the menu if it's open
                      if (window.location.pathname === "/about-us") {
                        e.preventDefault(); // Prevent the default navigation
                        window.location.reload(); // Reload the page
                      } else {
                        window.scrollTo(0, 0); // Scroll to the top for normal navigation
                      }
                    }}
                  >
                    <div className="hover-content">
                      <span
                        className="icon mx-2 px-4 py-2 rounded-4"
                        style={{ background: "#F0F8FF" }}
                      >
                        <img src={MedalIcon} alt="icon" />
                      </span>
                      <div>
                        <h6>About Us</h6>
                        <p>
                          We simplify gift card solutions with ease and
                          reliability
                        </p>
                      </div>
                    </div>
                  </NavLink>
                </div>
                <div className="hover-item">
                  <NavLink
                    to="/contact-us"
                    className="hover-link hover-effect"
                    style={{ color: "#000" }}
                    alt="Contact Us"
                    onClick={(e) => {
                      if (menuOpen) toggleMenu(); // Close the menu if it's open
                      if (window.location.pathname === "/contact-us") {
                        e.preventDefault(); // Prevent the default navigation
                        window.location.reload(); // Reload the page
                      } else {
                        window.scrollTo(0, 0); // Scroll to the top for normal navigation
                      }
                    }}
                  >
                    <div className="hover-content">
                      <span
                        className="icon mx-2 px-4 py-2 rounded-4"
                        style={{ background: "#F0F8FF" }}
                      >
                        <img
                          src={HeadphoneIcon}
                          alt="icon"
                          style={{ color: "blcak" }}
                        />
                      </span>
                      <div>
                        <h6>Contact Us</h6>
                        <p>When you need us, we are here to help</p>
                      </div>
                    </div>
                  </NavLink>
                </div>
              </div>
            </li>
            <li className="nav-item dropdown bordered">
              <NavLink
                className="nav-link hover-effect"
                id="giftCardHover"
                alt="Gift Cards"
                style={{ color: linkColor }}
                onClick={() => {
                  setHoverMenu({
                    giftCards: !hoverMenu.giftCards, // Toggle the current menu
                    giftCard8: false, // Close the other menu
                  });
                  window.scrollTo(0, 0);
                }}
              >
                Gift cards
              </NavLink>
              <div
                className={`hover-menu ${
                  hoverMenu.giftCards ? "show-sub-menu" : ""
                }`}
              >
                <div className="hover-item">
                  <NavLink
                    to="/sellGiftCards"
                    className="hover-link hover-effect"
                    style={{ color: "#000" }}
                    alt="Sell Gift Cards"
                    onClick={(e) => {
                      if (menuOpen) toggleMenu(); // Close the menu if it's open
                      if (window.location.pathname === "/sellGiftCards") {
                        e.preventDefault(); // Prevent the default navigation
                        window.location.reload(); // Reload the page
                      } else {
                        window.scrollTo(0, 0); // Scroll to the top for normal navigation
                      }
                    }}
                  >
                    <div className="hover-content">
                      <span
                        className="icon mx-2 px-4 py-2 rounded-4"
                        style={{ background: "#F0F8FF" }}
                      >
                        <img
                          src={GiftIcon}
                          alt="icon"
                          style={{ color: "#000" }}
                        />
                      </span>
                      <div>
                        <h6>Sell Gift Cards</h6>
                        <p>
                          Exchange your gift cards for cash at the best price
                          and get generous cash rewards
                        </p>
                      </div>
                    </div>
                  </NavLink>
                </div>
                <div className="hover-item">
                  <NavLink
                    to="/best-rates"
                    className="hover-link hover-effect"
                    style={{ color: "#000" }}
                    alt="Best Rates"
                    onClick={(e) => {
                      if (menuOpen) toggleMenu(); // Close the menu if it's open
                      if (window.location.pathname === "/best-rates") {
                        e.preventDefault(); // Prevent the default navigation
                        window.location.reload(); // Reload the page
                      } else {
                        window.scrollTo(0, 0); // Scroll to the top for normal navigation
                      }
                    }}
                  >
                    <div className="hover-content">
                      <span
                        className="icon mx-2 px-4 py-2 rounded-4"
                        style={{ background: "#F0F8FF" }}
                      >
                        <img src={RatesIcon} alt="icon" />
                      </span>
                      <div>
                        <h6>Gift Card Rates</h6>
                        <p>Enjoy premium rates for every transaction</p>
                      </div>
                    </div>
                  </NavLink>
                </div>
              </div>
            </li>
            <li className="nav-item bordered">
              <NavLink
                to="/blog"
                className="nav-link hover-effect"
                style={{ color: linkColor }}
                id="giftCardHover"
                alt="Blogs"
                onClick={(e) => {
                  if (menuOpen) toggleMenu();
                  if (window.location.pathname === "/blog") {
                    e.preventDefault();
                    window.location.reload();
                  } else {
                    window.scrollTo(0, 0);
                  }
                }}
              >
                Blogs
              </NavLink>
            </li>
            <li to="/faqs" className="nav-item">
              <NavLink
                to="/faqs"
                className="nav-link hover-effect"
                style={{ color: linkColor }}
                id="giftCardHover"
                alt="FAQs"
                onClick={(e) => {
                  if (menuOpen) toggleMenu();
                  window.scrollTo(0, 0);
                }}
              >
                FAQs
              </NavLink>
            </li>
          </div>
          <div className="large-button">
            <Button
              className="get-started"
              actionType="redirect"
              redirectUrl="https://dashboard.giftcard8.com/account"
              id="getStartedBtn"
            >
              Get Started
            </Button>
          </div>
        </div>
      </nav>
    </section>
  );
};
const styles = {
  background: `
        radial-gradient(
          circle at 40% 40%, 
          rgba(50, 50, 75, 0.5), 
          rgba(50, 50, 75, 0.1)
        ), 
        radial-gradient(
          circle at 60% 60%, 
          rgba(20, 20, 45, 0.7), 
          rgba(0, 0, 0, 1)
        )
      `,
};

export default NavBar;
